import { HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { BreadcrumbLink } from '../../../../../shared/interfaces/breadcrumb-link.interface'
import { Post } from '../../../../../shared/interfaces/resources/post.interface'
import { TaxonomyTerm } from '../../../../../shared/interfaces/taxonomy-term.interface'
import { BreadcrumbService } from '../../../../../shared/services/breadcrumb.service'
import { MetaService } from '../../../../../shared/services/meta.service'
import { PostService } from '../../../../../shared/services/post.service'
import { TagService } from '../../../../../shared/services/tag.service'

@Component({
  selector: 'app-tag-detail',
  templateUrl: './tag-detail.component.html',
  styleUrls: ['./tag-detail.component.scss']
})
export class TagDetailComponent implements OnInit {
  tag: TaxonomyTerm
  posts: Post[]
  breadcrumbLinks: BreadcrumbLink[]

  loadingPosts: boolean

  constructor(
    private activatedRoute: ActivatedRoute,
    private tagService: TagService,
    private breadcrumbService: BreadcrumbService,
    private postService: PostService,
    private router: Router,
    private metaService: MetaService
  ) {}

  ngOnInit() {
    this.loadingPosts = true

    this.activatedRoute.params.subscribe((params: Params) => {
      const tagId: string = params.idAndSlug.split('-')[0]

      this.tagService.show(tagId).then(
        (tagRes: TaxonomyTerm) => {
          this.tag = tagRes

          this.postService
            .listUnpaginated({ tagId })
            .then((postRes: Post[]) => {
              this.loadingPosts = false
              this.posts = postRes
            })

          this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
            'blogIndex',
            [
              {
                label: 'Tags'
              },
              {
                label: this.tag.name,
                path: `wonk/tags/${params.idAndSlug}`
              }
            ]
          )

          this.metaService.setTags({
            title: `Posts Tagged With "${this.tag.name}"`,
            description: `Discover all the OECD.AI Wonk Posts tagged with the keyword "${this.tag.name}"`,
            path: `wonk/tags/${params.idAndSlug}`
          })
        },
        (err: HttpErrorResponse) => {
          if (err.status === 404) {
            this.router.navigate(['/404'])
          }
        }
      )
    })
  }
}
